<div class="container">
  <div>
    <div >Min X</div>
    <dx-number-box style="float:left" [(value)]="plotConfig.minX" (onValueChanged)="valueChange()"></dx-number-box>
  </div>
  <div>
    <div >Max X</div>
    <dx-number-box [(value)]="plotConfig.maxX" (onValueChanged)="valueChange()"></dx-number-box>
  </div>
  <div>
    <div class="check">Log X</div>
    <dx-check-box [(value)]="plotConfig.logX" (onValueChanged)="valueChange()"></dx-check-box>
  </div>
  <div>
    <div >Min Y</div>
    <dx-number-box [(value)]="plotConfig.minY" (onValueChanged)="valueChange()"></dx-number-box>
  </div>
  <div>
    <div >Max Y</div>
    <dx-number-box [(value)]="plotConfig.maxY" (onValueChanged)="valueChange()"></dx-number-box>
  </div>
  <div>
    <div class="check">Log Y</div>
    <dx-check-box [(value)]="plotConfig.logY" (onValueChanged)="valueChange()"></dx-check-box>
  </div>
</div>
